import config from '@/assets/js/config'

const state = {
  isActiveMenu: false
}
const hideOnDesktop = () => {
  if (window.innerWidth > config.breakpoints.lg) {
    state.isActiveMenu = false
  }
}

const mutations = {
  toggleMenu (state) {
    state.isActiveMenu = !state.isActiveMenu
    window.addEventListener('resize', hideOnDesktop)
  },
  closeMenu (state) {
    state.isActiveMenu = false
  }
}

export default { state, mutations }



// WEBPACK FOOTER //
// ./src/store/modules/menu.js